import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import React, { useState } from 'react';
import { FaCheck, FaPlusCircle, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { mask, unMask } from 'remask';
import { Api } from '../../../services/api';
import { PasswordFullPague } from '../../../styles/primeReactConfig';

function NewAssociate({ close, reload }) {
  const [associateName, setAssociateName] = useState('');
  const [associateEmail, setAssociateEmail] = useState('');
  const [associateDoc, setAssociateDoc] = useState();
  const [associatePassword, setAssociatePassword] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  function handleCreateAssociate(event) {
    event.preventDefault();
    if (associateDoc.length === 14 || associateDoc.length === 18)
      setShowConfirm(true);
    else
      toast.error('Insira um CPF/CNPJ válido');
  }

  const createAssociate = async () => {
    const associateData = {
      associado_nome: associateName,
      associado_email: associateEmail,
      associado_documento: unMask(associateDoc, ['999.999.999-99', '99.999.999/9999-99']),
      password: associatePassword,
    }

    try {
      await toast.promise(Api.post('associados', associateData), {
        pending: 'Criando Usuário',
        success: 'Usuário adicionado com sucesso!',
        error: 'Erro ao criar novo usuário'
      });
      reload();
    } catch (error) {
      if (error.response.status === 409)
        toast.error('O E-mail informado já está cadastrado!');
      else
        toast.error('Erro de conexão');
    } finally {
      close();
    }
  }

  const footer = (
    <div className="w-full flex justify-between">
      <div className="grid w-1/3" >
        <Button
          severity='success'
          label="Sim"
          icon={<FaCheck />}
          onClick={() => { createAssociate() }} />
      </div>
      <div className="grid w-1/3" >
        <Button
          severity='danger'
          label="Não"
          icon={<FaTimes />}
          onClick={() => { setShowConfirm(false) }} />
      </div>
    </div>)

  return (
    <>
      <Dialog
        header="Deseja criar um novo usuário?"
        onHide={() => setShowConfirm(false)}
        visible={showConfirm}
        pt={{
          root: 'w-screen md:w-[50vw] lg:w-[30vw] h-auto',
          headerTitle: 'font-bold text-xl w-full text-center',
        }}
        footer={footer}
      >
        <div className="flex p-3 md:justify-between md:text-left text-center">
          <div className="grid items-start w-full md:w-7/12 mt-4">
            <h5><b>Nome: </b>{associateName}</h5>
            <h5><b>Email: </b>{associateEmail}</h5>
            <h5><b>Documento: </b>{associateDoc}</h5>
            <h5><b>Senha: </b>{associatePassword}</h5>
          </div>
          <div className="w-full md:w-1/3">
            <FaPlusCircle className='text-green-600 w-full h-auto' />
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Criar novo usuário"
        onHide={() => close()}
        visible
        pt={{
          root: 'w-screen md:w-[70vw] lg:w-[50vw] h-auto',
          headerTitle: 'font-bold text-xl w-full text-center',
        }}
      >
        <form onSubmit={(e) => handleCreateAssociate(e)}>
          <div className="grid w-full gap-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full gap-4 items-center" >
              <label htmlFor="associate_name" className=''>Nome do Usuário</label>
              <InputText
                id="associate_name"
                placeholder="ex: Everton Oliveira"
                value={associateName}
                onChange={(e) => setAssociateName(e.target.value)}
                type="text"
                required
              ></InputText>

              <label htmlFor="associate_email" className=''>E-mail do Usuário</label>
              <InputText
                id="associate_email"
                placeholder="ex: example@hotmail.com"
                value={associateEmail}
                onChange={(e) => setAssociateEmail(e.target.value)}
                type="email"
                required
              ></InputText>

            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full gap-4 items-center" >
              <label htmlFor="associate_document" className=''>Documento do Usuário</label>
              <InputText
                id="associate_document"
                placeholder="ex: 999.999.999-99"
                value={associateDoc}
                onChange={({ target }) =>
                  setAssociateDoc(
                    mask(unMask(target.value), [
                      '999.999.999-99',
                      '99.999.999/9999-99'
                    ])
                  )
                }
                type="text"
                required
              ></InputText>

              <label htmlFor="associate_password" className=''>Senha do Usuário</label>
              <Password
                id="associate_password"
                pt={PasswordFullPague}
                value={associatePassword}
                onChange={(e) => setAssociatePassword(e.target.value)}
                placeholder="ex: senha"
                required
                toggleMask
                feedback={false}
              ></Password>
            </div>
            <div className="w-full flex items-center justify-center mt-4">
              <div className="grid w-full md:w-2/3 lg:w-1/3">
                <Button
                  label="Enviar"
                  type="submit"
                  severity='success'
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  )
}

export default NewAssociate